(function(){
    angular
        .module('appback')
        .directive('ngVacunas', vacunas);

        vacunas.$inject = ['$timeout'];
        function vacunas($timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=vacunas.twig',
		          scope: {
                  //ngModel : '=',
                  item: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
				       				//console.log("resmd");
				       				//console.log(scope.item.resultado.extra.resultado);

					            }
				            }
				        }

			        });
		        }
          }
      }
})();